import { useCallback } from 'react'
import type { RefObject } from 'react'
import type { AgGridReact } from 'ag-grid-react'
import type { SuppressKeyboardEventParams } from 'ag-grid-community'
import { useGridSelection } from '../../../shared/hooks/useGridSelection'

/**
 * Excel-подобное выделение и копирование в карточке заявки (ItemsGrid).
 *
 * Тонкая обёртка над общим useGridSelection с одним дополнением —
 * suppressKeyboardEvent для стрелок в режиме редактирования: коммит +
 * переход на соседнюю ячейку, чтобы быстро вводить цены подряд без Enter.
 */
export function useItemsGridSelection(gridRef: RefObject<AgGridReact>) {
  const { onCellMouseDown, onCellMouseOver, getCellStyle } = useGridSelection(gridRef)

  // Стрелки вверх/вниз в режиме редактирования: коммитим значение и
  // переводим фокус на соседнюю ячейку.
  const suppressKeyboardEvent = useCallback((params: SuppressKeyboardEventParams): boolean => {
    if (!params.editing) return false
    const key = (params.event as KeyboardEvent).key
    if (key !== 'ArrowDown' && key !== 'ArrowUp') return false
    const api = params.api
    api.stopEditing(false)
    const current = params.node.rowIndex ?? 0
    const next = key === 'ArrowDown' ? current + 1 : current - 1
    const last = api.getDisplayedRowCount() - 1
    if (next < 0 || next > last) return true
    api.setFocusedCell(next, params.column)
    return true
  }, [])

  return { onCellMouseDown, onCellMouseOver, getCellStyle, suppressKeyboardEvent }
}
